var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DefaultWidget", {
    attrs: { name: "查看头像", icon: "mdi-account-circle-outline" },
    on: {
      click: function ($event) {
        return _vm.viewAvatar()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }